import React, { useCallback, useState } from "react";
import type {VoidFunctionComponent} from "react";
import {isUndefined} from "../../../util/is-type";
import {songLesson} from "../../../services/songs/songLesson";
import {FavoriteToggle} from "../../songs/favorite-toggle/FavoriteToggle";
import {IUserLibraryAddLessonResponse} from "../../../client/models/user-library/IUserLibraryAddLessonResponse";

export interface ILibraryLessonCardFavoriteActionProps {
  lessonId?: number;
  isFavorite?: boolean;
}

export const LibraryLessonCardFavoriteAction: VoidFunctionComponent<ILibraryLessonCardFavoriteActionProps> = ({lessonId, isFavorite}) => {
  /**
   * This feels like a hack.
   * We're getting whether the lesson is favorite from the API response for all unlocked lessons.
   * Then we record a different state here, allowing the component to override the data from the original API response.
   * Also, we're sending events to the Redux store,
   *  which does not exist when this component is used in the unlocked lessons page.
   * Maybe if we weren't using Redux this would feel less like a hack.
   */
  const [isFavoriteNow, setIsFavoriteNow] = useState(isFavorite);

  const favoriteActionHandler = useCallback(() => {
    if (isUndefined(lessonId)) {
      // can't update anything, return to exit
      return;
    }

    let response: Promise<IUserLibraryAddLessonResponse|void>;

    if (isFavoriteNow) {
      response  = songLesson.removeFavoriteExistingLibraryLesson(lessonId);
    } else {
      response = songLesson.favoriteExistingLibraryLesson(lessonId);
    }

    response.then((result) => {
      setIsFavoriteNow(result?.isFavorited);
    });
  }, [lessonId, isFavoriteNow]);

  return <FavoriteToggle onChangeHandler={favoriteActionHandler} isFavorited={isFavoriteNow} />
}
